
const selectDropdowns = () => {
    const selector = 'select.select:not(.select2)';

    $(document).arrive(selector, {
        existing: true
    }, function() {
        const options = {
            noneSelectedText: '',
            dropupAuto: false
            // "optionClass": "withripple"
        };
        const element = $(this);

        // Prevent multiple initializations
        if (element.data('selectpicker-initialized')) {
            return
        }
        element.data('selectpicker-initialized', true);

        element.selectpicker(options);
    });
};

export {
    selectDropdowns
}


// WEBPACK FOOTER //
// ./js/form/select.js